import { SeoLinks } from "@hermes/fragments/seo-links";
import { LocaleUrlPrefix } from "@hermes/locale";
import { generateCityPath, generateCountryPath } from "@hermes/shop-utils";
import {
    CityEntry,
    CountryEntry,
    CountryState,
    CurrentShopLocation,
    SHOP_LOCATIONS_CITY_MODE,
    SHOP_LOCATIONS_COUNTRY_MODE,
} from "@hermes/states/shop-locations";

/**
 * Generate SEO links accessible from navigation bar for each type of page (home, country, city)
 */
export const generateSeoLinks = (
    url: {
        base: string;
        prefix: LocaleUrlPrefix;
    },
    location: {
        current: CurrentShopLocation;
        countries: CountryEntry[];
        cities: CityEntry[];
    },
): SeoLinks => {
    if (location.current.pageMode === SHOP_LOCATIONS_COUNTRY_MODE) {
        return location.cities.map((city: CityEntry) => ({
            path: `${url.base}${url.prefix}/${generateCityPath(
                (location.current as Pick<CountryState, "currentCountry">)
                    .currentCountry.slugifiedCountry,
                city.slugifiedCity,
            )}`,
            label: city.slugifiedCity,
        }));
    }

    if (location.current.pageMode === SHOP_LOCATIONS_CITY_MODE) {
        return [
            {
                path: `${url.base}${url.prefix}/${generateCountryPath(
                    location.current.currentCountry.slugifiedCountry,
                )}`,
                label: location.current.currentCountry.slugifiedCountry,
            },
        ];
    }

    return location.countries.map((country: CountryEntry) => ({
        path: `${url.base}${url.prefix}/${generateCountryPath(
            country.slugifiedCountry,
        )}`,
        label: country.slugifiedCountry,
    }));
};
